import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface MetricCardProps {
  label: string;
  value: string | number;
  subtext?: string;
  trend?: { direction: 'up' | 'down' | 'flat'; value: string; positive?: boolean };
  icon: string;
  variant?: 'default' | 'danger' | 'warning' | 'success' | 'info';
  className?: string;
}

const variantConfig = {
  default: {
    card: 'bg-surface border-border',
    icon: 'bg-sky-500/10 text-sky-400',
    value: 'text-white',
  },
  danger: {
    card: 'bg-red-500/5 border-red-500/20',
    icon: 'bg-red-500/10 text-red-400',
    value: 'text-red-400',
  },
  warning: {
    card: 'bg-amber-500/5 border-amber-500/20',
    icon: 'bg-amber-500/10 text-amber-400',
    value: 'text-amber-400',
  },
  success: {
    card: 'bg-green-500/5 border-green-500/20',
    icon: 'bg-green-500/10 text-green-400',
    value: 'text-green-400',
  },
  info: {
    card: 'bg-sky-500/5 border-sky-500/20',
    icon: 'bg-sky-500/10 text-sky-400',
    value: 'text-sky-400',
  },
};

export default function MetricCard({ label, value, subtext, trend, icon, variant = 'default', className = '' }: MetricCardProps) {
  const cfg = variantConfig[variant];

  return (
    <div className={`rounded-xl border p-4 flex flex-col gap-3 ${cfg.card} ${className}`}>
      <div className="flex items-start justify-between">
        <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${cfg.icon}`}>
          <Icon name={icon as any} size={18} />
        </div>
        {trend && (
          <span className={`text-xs font-medium flex items-center gap-0.5 ${
            trend.positive === undefined ? 'text-secondary-color' : trend.positive ?'text-green-400' : 'text-red-400'
          }`}>
            {trend.direction === 'up' && <Icon name="ArrowUpIcon" size={12} />}
            {trend.direction === 'down' && <Icon name="ArrowDownIcon" size={12} />}
            {trend.value}
          </span>
        )}
      </div>
      <div>
        <p className={`text-2xl font-bold tabular-nums font-mono ${cfg.value}`}>{value}</p>
        <p className="text-xs font-medium text-muted-color mt-0.5 tracking-wide uppercase">{label}</p>
        {subtext && <p className="text-xs text-secondary-color mt-1">{subtext}</p>}
      </div>
    </div>
  );
}